import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from 'react';
import { ZIP_CODE_REGEX, ZIPCODE_ERROR_MESSAGES } from 'commons/constants';
import useCityStatePlacesAutocomplete from 'hooks/useCityStatePlacesAutocomplete';
const useShowroomSearchInput = t0 => {
  const $ = _c(14);
  const {
    inputRef,
    onValueChange,
    onSearchByZipcode,
    onSearchByPlace
  } = t0;
  const selectedPlaceRef = useRef(null);
  let t1;
  if ($[0] !== onSearchByPlace || $[1] !== onValueChange) {
    t1 = place => {
      selectedPlaceRef.current = place;
      onValueChange(place.label);
      onSearchByPlace(place);
    };
    $[0] = onSearchByPlace;
    $[1] = onValueChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handlePlaceSelected = t1;
  let t2;
  if ($[3] !== handlePlaceSelected || $[4] !== inputRef) {
    t2 = {
      inputRef,
      onPlaceSelected: handlePlaceSelected
    };
    $[3] = handlePlaceSelected;
    $[4] = inputRef;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const suggestionsDropdownProps = useCityStatePlacesAutocomplete(t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = value => {
      const trimmed = (value || "").toString().trim();
      if (selectedPlaceRef.current && trimmed !== selectedPlaceRef.current.label) {
        selectedPlaceRef.current = null;
      }
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const notifyValueChanged = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = value_0 => {
      const trimmed_0 = (value_0 || "").toString().trim();
      if (!trimmed_0) {
        return ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_EMPTY;
      }
      if (selectedPlaceRef.current && trimmed_0 === selectedPlaceRef.current.label) {
        return "";
      }
      if (!ZIP_CODE_REGEX.test(trimmed_0)) {
        return ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_INVALID_FORMAT;
      }
      return "";
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const validateValue = t4;
  let t5;
  if ($[8] !== onSearchByPlace || $[9] !== onSearchByZipcode) {
    t5 = value_1 => {
      const trimmed_1 = (value_1 || "").toString().trim();
      if (selectedPlaceRef.current && trimmed_1 === selectedPlaceRef.current.label) {
        onSearchByPlace(selectedPlaceRef.current);
        return;
      }
      onSearchByZipcode(trimmed_1);
    };
    $[8] = onSearchByPlace;
    $[9] = onSearchByZipcode;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const submitValue = t5;
  let t6;
  if ($[11] !== submitValue || $[12] !== suggestionsDropdownProps) {
    t6 = {
      notifyValueChanged,
      validateValue,
      submitValue,
      suggestionsDropdownProps
    };
    $[11] = submitValue;
    $[12] = suggestionsDropdownProps;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default useShowroomSearchInput;